import { createSelector } from 'reselect'

export const getPaidAds = createSelector(
  (state) => state && state.ads && state.ads.list && state.ads.list.paid ? state.ads.list.paid : [],
  (ads) => ads
)
